import { render, staticRenderFns } from "./cPagination_new.vue?vue&type=template&id=2978cbf6&scoped=true"
import script from "./cPagination_new.vue?vue&type=script&lang=js"
export * from "./cPagination_new.vue?vue&type=script&lang=js"
import style0 from "./cPagination_new.vue?vue&type=style&index=0&id=2978cbf6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2978cbf6",
  null
  
)

export default component.exports